import React, { useEffect, useState, useRef } from "react";
import BottomNav from "../components/BottomNav";
import Container from "../components/Container";
import Description from "../components/Description";
import FinancialHealthCheckup from "../components/FinancialHealthCheckup";
import Heading from "../components/Heading";
import Input from "../components/Input";
import PieGraph from "../components/PieGraph";
import { BarChart, Bar, XAxis, YAxis, ReferenceLine, Cell,Tooltip , CartesianGrid,ResponsiveContainer } from 'recharts';
import { kFormatter } from "../libs";
import ResultInput from "../components/ResultInput";
import { BarChart1 } from "../components/BarChart1";
import {useSelector,useDispatch} from 'react-redux'
import  { actions } from '../store/index'
import YourFHC from "../components/YourFHC";
import { Link } from "react-router-dom";


const renderCustomBarLabel = ({ payload, x, y, width, height, value }) => {
    return <text x={x + width / 2} y={y} fill="#0A1827" textAnchor="middle" dy={value < 0 ? 16 : -6} >{`${value.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}`}</text>;
};

const FHC = () => {

    const counter=useSelector((state)=>state.formdata)
    const dispatch=useDispatch()
    const hasCodeExecuted = useRef(false);

    const [formData, setFormData] = useState({
        M1: null,
        M2: null,
        M3: null,
        M4: null,
        T1: null,
        T2: null,
        T3: null,
        T4: null,
      
    });

    const [resultData, setResultData] = useState({
        R1: 0,
        R2: 0,
        R3: 0,
        R4: 0,
        R5: 0
    });


    const [Slack, setSlack] = useState(0);
    const [Networth, setNetworth] = useState(0);
    const changeHandler = (e) => {
        setFormData({
            ...formData,
            [e.target.id]: e.target.value
        });

        // const data=[...formData]
     
    };

    const update=()=>
    {
        Object.keys(counter).length>0?
        setFormData(counter):
        setFormData(formData)
    }

    useEffect(() => {

        if (!hasCodeExecuted.current) {

            update()
            hasCodeExecuted.current = true;

            window.scrollTo(0, 0);

        }

        const { M1, M2, M3, M4, T1, T2, T3, T4 } = formData;
        setResultData({
            R1: (Number(M3) / Number(M1)) * 100,
            R2: Number(T1) / (Number(M2) + Number(M3) + Number(M4))*100,
            R3: ((Number(T1) + Number(T2)) / (Number(T3) + Number(T4)) * 100),
            R4: (Number(T1) / (Number(M3) + Number(M4)) * 100),
            R5: (Number(M4) / Number(M1) * 100)
        });
        setCartData([
          
            {
            name: 'Total Savings',
            value: Number(T1),
            color: "green"
        },
        {
            name: 'Investments',
            value: Number(T2),
            color: "green"
        },
        {
            name: 'Total Debt',
            value: -Number(T3),
            color: "red"
        },
        {
            name: 'Mortgage',
            value: -Number(T4),
            color: "pink"
        },
        {
            name: 'Net Woth',
            value: Number(Networth),
            color: "green"
        }
    
    ]);
    dispatch(actions.updateFormData(formData))

        
    // alert(JSON.stringify(counter))

        setSlack(Number(M1) - (Number(M2) + Number(M3) + Number(M4)));
        setNetworth((Number(T1) + Number(T2)) - Number(T3));
        
    }, [formData, Slack,Networth]);


    const [chartData, setCartData] = useState([{
        name: 'Total Savings',
        value: Number(formData.T1),
        color: "green"
    },
    {
        name: 'Investments',
        value: Number(formData.T2),
        color: "green"
    },
    {
        name: 'Total Debt',
        value: -Number(formData.T3),
        color: "red"
    },
    {
        name: 'Mortgage',
        value: -Number(formData.T4),
        color: "pink"
    }]);

    return (
        <div className="w-full">
            <div className="bg-gradient-to-b h-72 from-primary to-patric-blue">
                <Container classes={"flex flex-col p-4 px-5 space-y-6 md:space-y-0  md:py-10 md:flex-row items-center w-full justify-between"}>
                    <div className="w-full md:w-auto">
                        <Link to={'/'}>
                        <img src="./assets/images/logo-white.png" alt="logo" />
                        </Link>
                        
                        </div>
                    <h1 className="text-white font-bold text-center text-2xl md:text-4xl">Financial Health Checkup</h1>
                    <div className="hidden md:block"></div>
                </Container>
                    <div className="text-white  text-center mb:mx-0 mx-5 md:ml-40 -mt-3 md:-mt-7 text-lg md:text-2xl">See where you stand today. Awareness is where it all begins</div>
            </div>
            <Container classes={"-mt-24 md:-mt-32 py-10 space-y-6"}>
            <div className="flex flex-col md:flex-row items-start space-y-10 md:space-y-0 md:space-x-6">
                    <div className="flex-1 w-full md:flex md:space-x-10 md:space-y-0 space-y-10 ">
                        <div className="shadow-md p-6 bg-white space-y-6">
                            <Heading text={"Basic Financial Inputs"} icon={"financial-input"} />
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 gap-4 md:gap-y-8 lg:gap-x-20">
                                <Input type={"number"} id={"M1"} value={formData.M1} label={"Monthly Income"} onChange={changeHandler} />
                                <Input type={"number"} id={"T1"} value={formData.T1} label={"Total Savings (Liquid Funds)"} onChange={changeHandler} />
                                <Input type={"number"} id={"M2"} value={formData.M2} label={"Monthly Expenses"} onChange={changeHandler} />
                                <Input type={"number"} id={"T2"} value={formData.T2} label={"Stocks, bonds, real estate etc."} onChange={changeHandler} />
                                <Input type={"number"} id={"M3"} value={formData.M3} label={"Monthly Debt pmt (credit card, car etc)"} onChange={changeHandler} />
                                <Input type={"number"} id={"T3"} value={formData.T3} label={"Total Debt (except mortgage)"} onChange={changeHandler} />
                                <Input type={"number"} id={"M4"} value={formData.M4} label={"Housing / Rent, Tax, Inurance"} onChange={changeHandler} />
                                <Input type={"number"} id={"T4"} value={formData.T4} label={"Mortgage Balance"} disable onChange={changeHandler} />
                            </div>

                        
                        </div>


                    

<YourFHC R1={resultData.R1} R2={resultData.R2} R3={resultData.R3} R4={resultData.R4} R5={resultData.R5} Slack={Slack}/>


                   
                    </div>

                </div>

                <div className="block md:flex pt-10 px-5">

<div className="hidden md:block w-7/12">
    <PieGraph heading="Current Surplus" subheading="Monthly Expenses vs Savings" M1={formData.M1} M2={formData.M2} M3={formData.M3} M4={formData.M4} />
</div>
<div className="md:hidden">
    <PieGraph heading="Current Surplus" subheading="Monthly Expenses vs Savings" M1={formData.M1} M2={formData.M2} M3={formData.M3} M4={formData.M4} />
</div>
<div className="md:pl-14 mt-10 md:mt-24">
    <Description R1={resultData.R1} R2={resultData.R2} R3={resultData.R3} R4={resultData.R4} R5={resultData.R5} Networth={Networth} />
</div>




</div>



                <div className="space-y-10">
                    <div className='flex justify-center'>
                        <h2 className='bg-primary/10 text-primary rounded-xl py-2 px-4 text-base md:text-xl'>Total Assets vs Liabilities</h2>
                    </div>
                    <div className="bg-primary/5  rounded-xl p-4">
                        <div className='w-full h-full'>
                           
                    <BarChart1 T1={formData.T1} T2={formData.T2} T3={formData.T3} T4={formData.T4} Net={Networth}/>
                        </div>
                    </div>
                    <BottomNav />
                </div>
            </Container>
        </div>
    );
};

export default FHC;